// extracted by mini-css-extract-plugin
export var container = "Feature-module--container--b0l5b";
export var feature = "Feature-module--feature--GcnR0";
export var inverted = "Feature-module--inverted--enNcD";
export var title = "Feature-module--title--axFW+";
export var cover = "Feature-module--cover--gh2Jr";
export var description = "Feature-module--description--vl1RR";
export var noCover = "Feature-module--no-cover--VzZX+";